// Where a wall texture region sits on its wall. Moved verbatim out of
// estimate-pricing/utils/roomTakeOffs.js (which re-exports both), so the
// take-off's tile maths and baseboard's finish stops read one copy.

// Convert a wall texture region (x, y, width, height in 0–100 % of the
// wall surface) into a rect in wall-local meters where a is along the
// wall ([0, wallLen]) and y is up from the floor ([0, wallHeight]).
function regionRectOnWall(region, wallLen, wallH) {
  const xPct = clampPct(region.x ?? 0);
  const yPct = clampPct(region.y ?? 0);
  const wPct = clampPct(region.width ?? 100);
  const hPct = clampPct(region.height ?? 100);
  const a0 = (xPct / 100) * wallLen;
  const a1 = Math.min(wallLen, ((xPct + wPct) / 100) * wallLen);
  const y0 = (yPct / 100) * wallH;
  const y1 = Math.min(wallH, ((yPct + hPct) / 100) * wallH);
  return { a0, a1, y0, y1 };
}

const clampPct = (v) => (v < 0 ? 0 : v > 100 ? 100 : v);

module.exports = { regionRectOnWall, clampPct };
